import EditIcon from '@mui/icons-material/Edit';
import { Button, Stack, Typography } from '@mui/material';
import ColoredAvatar from 'core/components/ColoredAvatar';
import { getClientTypeName } from 'core/utils/clientUtils';
import PageHeaderBackLink from 'layout/pages/PageHeaderBackLink';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { useNavigate } from 'react-router-dom';
import type { Client } from 'models/client/client';

const ClientViewPageHeader = ({ client }: ClientPageHeaderProps): JSX.Element => {
  const navigate = useNavigate();

  const toEdit = (): void => {
    navigate('edit');
  };

  return (
    <PageHeaderWrapper>
      <Stack spacing={2}>
        <PageHeaderBackLink to='/clients' name='Клиенты' />
        <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center' }}>
          <ColoredAvatar alt={client?.surname}>{client?.surname?.[0]}</ColoredAvatar>
          <Stack>
            <PageHeaderText text={client?.fullName ?? 'Клиент'} />
            <Typography color={'text.secondary'}>
              {getClientTypeName(client?.type ?? 0)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Button variant='contained' onClick={toEdit} startIcon={<EditIcon />}>
        Редактировать
      </Button>
    </PageHeaderWrapper>
  );
};

export interface ClientPageHeaderProps {
  client?: Client;
}

export default ClientViewPageHeader;
